export { default } from "./FormativeLogoIcon";
